import { render } from "./ProviderGroupsOverlay.vue?vue&type=template&id=d561ba08&scoped=true&lang=pug"
import script from "./ProviderGroupsOverlay.vue?vue&type=script&lang=js"
export * from "./ProviderGroupsOverlay.vue?vue&type=script&lang=js"

import "./ProviderGroupsOverlay.vue?vue&type=style&index=0&id=d561ba08&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d561ba08"]])

export default __exports__